const methods = {
	setOpacity (val, layer) {
		let l = layer.$layer
		l.setOpacity(val / 100)
	},
	getOpacity (layer) {
		let l = layer.$layer
		return Math.ceil(l.getOpacity() * 100)
	},
    addLayers(layers) {
    	// this.layers = layers
    	this.layers.push(layers)
    },
    getLayerName(lyr) {
    	return lyr.legendName;
    },
}

export default {
	methods
}


// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/legend/legend-container.js